export const userErrorEnum = {
  GeneralFailedRegisterUser: "GeneralFailedRegisterUser",
  GeneralFailedLoginUser: "GeneralFailedLoginUser",
  InccorectUserPassword: "InccorectUserPassword",
  UserNotFound: "UserNotFound",
};
